import { render, staticRenderFns } from "./AnswerThumb.vue?vue&type=template&id=47c79604"
import script from "./AnswerThumb.vue?vue&type=script&lang=js"
export * from "./AnswerThumb.vue?vue&type=script&lang=js"
import style0 from "./AnswerThumb.vue?vue&type=style&index=0&id=47c79604&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports